import React, { useState } from 'react';
import PropTypes from 'prop-types';
import './Table.css'; // Asegúrate de crear y ajustar este archivo CSS según tus necesidades

const Table = ({ data, columns, onRowClick, onRowDoubleClick }) => {
  const [selectedRows, setSelectedRows] = useState(new Set());

  const handleSelection = (counter, e) => {
    if (e.ctrlKey) {
      if (selectedRows.has(counter)) {
        selectedRows.delete(counter);
      } else {
        selectedRows.add(counter);
      }
      setSelectedRows(new Set(selectedRows));
      const selectedData = [...selectedRows].map(index => data[index]);
      onRowClick(selectedData);
    } else {
      setSelectedRows(new Set([counter]));
      const selectedData = [data[counter]];
      onRowClick(selectedData);
    }
  };
  

  const handleDoubleClick = (row) => {
    onRowDoubleClick(row);
  };

  return (
    <div className="table-into">
      <table>
        <thead>
          <tr>
            {columns.map((col) => (
              <th key={col.field}>{col.header}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => {
            return (
              <tr
                key={index}
                onDoubleClick={() => handleDoubleClick(row)}
                onClick={(e) => handleSelection(index, e)}
                className={selectedRows.has(index) ? 'selected' : ''}
              >
                {columns.map((col) => (
                  <td key={`${index}-${col.field}`} title={row[col.field]} className="tooltip">
                    {row[col.field]}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

Table.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  columns: PropTypes.arrayOf(PropTypes.shape({
    header: PropTypes.string.isRequired,
    field: PropTypes.string.isRequired,
  })).isRequired,
  onRowClick: PropTypes.func.isRequired,
  onRowDoubleClick: PropTypes.func.isRequired,
};

export default Table;
